export default __webpack_public_path__ + "static/media/london.b294ac43.jpg";